import { HttpService } from './HttpService';

export class ReportService extends HttpService {

    constructor(url: string) {
        super(url);
    }

    public async getProductsSold(fromDate: Date, toDate: Date): Promise<any> {
        const response: any = await this.post("/reports/products-sold", {
            from_date: fromDate,
            to_date: toDate
        })

        if (Array.isArray(response.data)) {
            return response.data;
        }
        return [];
    }

    public async getRestaurantsSales(fromDate: Date, toDate: Date): Promise<any> {
        const response: any = await this.post("/reports/restaurants-sales", {
            from_date: fromDate,
            to_date: toDate
        })

        if (Array.isArray(response.data)) {
            return response.data;
        }
        return [];
    }

    public async getRestaurantSales(fromDate: Date, toDate: Date): Promise<any> {
        const response: any = await this.post("/reports/restaurant-sales", {
            from_date: fromDate,
            to_date: toDate
        })

        if (Array.isArray(response.data)) {
            return response.data[0];
        }
        return [];
    }

    public async getAverageCover(fromDate: Date, toDate: Date): Promise<any> {
        const response: any = await this.post("/reports/average-cover", {
            from_date: fromDate,
            to_date: toDate
        })

        if (Array.isArray(response.data)) {
            return response.data[0];
        }
        return [];
    }

    public async getTableTurnoverRate(fromDate: Date, toDate: Date): Promise<any> {
        const response: any = await this.post("/reports/table-turnover-rate", {
            from_date: fromDate,
            to_date: toDate
        })

        if (Array.isArray(response.data)) {
            return response.data;
        }
        return [];
    }

    public async getTotalTips(fromDate: Date, toDate: Date): Promise<any> {
        const response: any = await this.post("/reports/total-tips", {
            from_date: fromDate,
            to_date: toDate
        })

        if (Array.isArray(response.data)) {
            return response.data[0];
        }
        return [];
    }

    public async getSalesPerDay(fromDate: Date, toDate: Date): Promise<any> {
        const response: any = await this.post("/reports/sales-per-day", {
            from_date: fromDate,
            to_date: toDate
        })

        if (Array.isArray(response.data)) {
            return response.data;
        }
        return [];
    }

    public async getFoodVsDrinks(fromDate: Date, toDate: Date): Promise<any> {
        const response: any = await this.post("/reports/food-vs-drinks", {
            from_date: fromDate,
            to_date: toDate
        })

        if (Array.isArray(response.data)) {
            return response.data;
        }
        return [];
    }

    public async getCostsVsProfit(fromDate: Date, toDate: Date): Promise<any> {
        const response: any = await this.post("/reports/costs-vs-profit", {
            from_date: fromDate,
            to_date: toDate
        })

        if (Array.isArray(response.data)) {
            return response.data[0];
        }
        return [];
    }
}
